import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';

export class GameWinUtils {
	public static isBigWinNoMultiplier(logic: GameRecodeLogic): boolean {
		return logic.getLastAvalancheRunningTotal() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
	}

	public static isBigWinWithMultiplier(logic: GameRecodeLogic): boolean {
		return logic.currentSpinWin >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
	}
}



// WEBPACK FOOTER //
// ./src/logic/GameWinUtils.ts